import React from "react";

import MainHeader from "./MainHeader";
import MainContent from "./MainContent";



function LayoutAccessories()
{


    return (
       <div className="pageAccessories">
          
            <MainHeader />
            <MainContent />
       </div>
    )
}

export default LayoutAccessories